<template>
  <div>
    <!--nav bar-->
    <v-app-bar v-if="!$vuetify.breakpoint.smAndDown" app color="black" elevation="0" :height="barHeight" class="navbar">
      <div class="navbar-inner">
        <div class="img-logo">
          <router-link to="/home"><v-img
              :src="require(`../../../public/img/white_logo.png`)"></v-img></router-link>
        </div>
        <div style="height:52px">
          <v-divider inset vertical style="height:100%"></v-divider>
        </div>

        <div v-if="pageTitle" class="d-flex flex-column">
          <h3 style="line-height:1.3rem; font-weight: 900; font-size:1.4rem" class="mt-1">
            {{ coreStore.getApplicationName(pageTitle).title }}</h3>
          <h5 class="text-caption mt-1" style="line-height:1rem; white-space: nowrap; color:hsl(0, 0%, 65%);">
            {{ $t(coreStore.getApplicationName(pageTitle).descKey) }}</h5>
        </div>

        <div class="market-bar-wrap">
          <header-market-bar />
        </div>

        <options-toolbar />

        <hamburguer-menu />

      </div>
    </v-app-bar>
    <!--nav bar mobile-->
    <v-app-bar v-if="$vuetify.breakpoint.smAndDown" app color="black" elevation="0" height="56" class="navbar navbar--mobile">
      <div class="navbar-inner">
        <div class="img-logo">
          <router-link to="/home">
            <v-img :src="require(`../../../public/img/white_logo.png`)"></v-img>
          </router-link>
        </div>
        <hamburguer-menu />
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import { useCoreStore } from "@/store/coreStore";
import { useAuthStore } from "@/store/authStore.js";
import { useFxMarketStore,  useExecutionStore, useSettingsStore } from "@/store/index";
import { mapStores, mapActions, mapWritableState, mapState } from "pinia";
import * as utils from '@/utils/utils';
import HeaderMarketBar from "./HeaderMarketBar.vue";
import OptionsToolbar from "./OptionsToolbar.vue";
import HamburguerMenu from "./HamburguerMenu.vue";
export default {
  components: { HeaderMarketBar, OptionsToolbar, HamburguerMenu },
  data() {
    return {
      drawer: true,
      intervalMinutely: null,
      intervalHourly: null,
      openGroups: {},
      hasFetchedHourlySuccess: false,
    };
  },
  props: {
    pageTitle: {
      type: String,
      required: false,
    },
    activeLink: {
      type: String,
      required: false,
    },
  },
  mounted() {
    this.checkLastFetchHourlyAndUpdate();
    this.intervalHourly = setInterval(() => {
      if (!this.hasFetchedHourlySuccess) {
        this.checkLastFetchHourlyAndUpdate();
      }
    }, 10 * 60 * 1000);

    this.fetchMinutelyAndUpdate();
  },
  beforeDestroy() {
    if (this.logo) {
      URL.revokeObjectURL(this.logo);
    }
    clearInterval(this.intervalMinutely);
    clearInterval(this.intervalHourly);
    clearInterval(this.intervalId);
  },
  computed: {
    ...mapStores(useCoreStore, useSettingsStore),

    // A altura da barra e ditada pelo conteudo mais alto dela, que nao e o
    // titulo nem o logo (45px e 29px) - e o carrossel de noticias, que fixa a
    // propria altura em 120px na fonte LG e 80px nas outras duas. O calendario
    // vem logo atras: sao sempre 3 eventos empilhados, ~72px.
    // O 130 fixo que existia aqui era o numero certo para LG e deixava ~35px de
    // ar sobrando nas outras duas, que sao o caso comum (o default e MD).
    barHeight() {
      return this.settingsStore.fontsize === 'LG' ? 130 : 96
    },
    ...mapWritableState(useFxMarketStore, [
      "fxMarketIntradayData",
      "fxMarketNews",
      "fxMarketAvgPtax",
      "fxMarketDailyData",
      "fxMarketEconomicCalendar",
      "fxMarketLoading",
    ]),
    ...mapState(useFxMarketStore, [
      "getFxMarketIntradayData",
      "getFxMarketIsLoading",
    ]),

    fxMarketIntradayList() {
      if (!this.getFxMarketIntradayData) return;
      return this.getFxMarketIntradayData?.data;
    },
    duplicatedFxMarketIntradayList() {
      const entries = Object.entries(this.fxMarketIntradayList || {});
      return [...entries, ...entries];
    },
    isPtBRLocale() {
      return this.$i18n.locale === "pt";
    },
    fxMarketIntradayList() {
      if (!this.getFxMarketIntradayData) return;
      return this.getFxMarketIntradayData?.data;
    },
  },
  methods: {
    ...mapActions(useFxMarketStore, [
      "getBrokerMarketdata",
      "getFxMarketDataMinutely",
      "getYesterdayTimeZone",
      "getFxMarketDataHourly",
    ]),

    fetchFxMarketDataHourly(date_ptax = utils.getOffsetDate(0, true)) {
      const from_date = utils.getOffsetDate(0);
      const to_date = utils.getOffsetDate(10);
      const countries = "US,EU,BR";

      this.getFxMarketDataHourly(from_date, to_date, countries, date_ptax)
        .then((response) => {
          const { data, errors } = response.data;

          if (errors && Object.keys(errors).length > 0) {
            console.log(errors);
          }

          const events = data["fx-market-economic-calendar"]?.result || [];
          const fxMarketDailyList = data["fx-market-daily-data"] || null;
          let avgPtax = data["fx-market-avg-ptax"] || null;

          this.fxMarketEconomicCalendar = events;
          this.fxMarketDailyData = fxMarketDailyList;

          localStorage.setItem(
            "fxMarketEconomicCalendar",
            JSON.stringify(events),
          );
          localStorage.setItem(
            "fxMarketDailyData",
            JSON.stringify(fxMarketDailyList),
          );

          if (avgPtax?.error) {
            const fallbackDate = utils.getOffsetDate(-1, true);
            return this.fetchFxMarketDataHourly(fallbackDate);
          }

          this.fxMarketAvgPtax = avgPtax;
          localStorage.setItem("avgPtax", JSON.stringify(avgPtax));
          localStorage.setItem("lastFetchHourlyTime", new Date().toISOString());

          this.hasFetchedHourlySuccess = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchFxMarketDataMinutely() {
      // const topics = "economy_monetary,financial_markets,economy_macro,finance"
      const time_from = this.getYesterdayTimeZone();

      this.getFxMarketDataMinutely(time_from)
        .then((response) => {
          const data = response.data;
          const fxMarketNews = data["fx-market-news"];
          const fxMarketIntradayList = data["fx-market-intraday-data"];
          this.fxMarketNews = fxMarketNews;
          this.fxMarketIntradayData = fxMarketIntradayList;
          localStorage.setItem("fxMarketNews", JSON.stringify(fxMarketNews));
          localStorage.setItem(
            "fxMarketIntradayData",
            JSON.stringify(fxMarketIntradayList),
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkLastFetchHourlyAndUpdate() {
      const lastFetchHourlyTime = localStorage.getItem("lastFetchHourlyTime");
      const now = new Date();

      if (lastFetchHourlyTime) {
        const lastFetchDate = new Date(lastFetchHourlyTime);
        const timeDifference = (now - lastFetchDate) / (1000 * 60);

        if (timeDifference > 60) {
          this.fetchFxMarketDataHourly();
          return;
        }
      } else {
        this.fetchFxMarketDataHourly();
      }
      this.fxMarketEconomicCalendar = JSON.parse(
        localStorage.getItem("fxMarketEconomicCalendar"),
      );
      this.fxMarketAvgPtax = JSON.parse(localStorage.getItem("avgPtax"));
      this.fxMarketDailyData = JSON.parse(
        localStorage.getItem("fxMarketDailyData"),
      );
    },
    fetchMinutelyAndUpdate() {
      this.fetchFxMarketDataMinutely();
      this.intervalMinutely = setInterval(() => {
        this.fetchFxMarketDataMinutely();
      }, 60000);
      this.fxMarketNews = JSON.parse(localStorage.getItem("fxMarketNews"));
      this.fxMarketIntradayData = JSON.parse(
        localStorage.getItem("fxMarketIntradayData"),
      );
    },

    ...mapActions(useAuthStore, [
      "changePasswordUser",
      "logout",
      "removeSessionLocalStorage",
      "getUserRoleFromLocalStorage",
      "registerBrokerEmail",
    ]),
    ...mapActions(useExecutionStore, [
      "getBankIdList",
      "putBroker",
      "getBrokerLogo",
      "uploadBrokerLogo",
      "getBrokerById",
      "getMockBanks",
      "getBrokerClients",
      "getCompanyById",
      "getBankById",
      "putBankByCnpj",
      "putCompany",
      "saveBrokerClients",
      "setImgToDB",
    ]),
    ...mapActions(useFxMarketStore, [
      "getBrokerMarketdata",
      "getFxMarketDataMinutely",
      "getYesterdayTimeZone",
      "getFxMarketDataHourly",
    ]),
    ...mapActions(useSettingsStore, [
      "toggleMockData",
      "setTimezone",
      "setFontSize",
      "setSpreadType",
    ]),
    fetchFxMarketDataHourly(date_ptax = utils.getOffsetDate(0, true)) {
      const from_date = utils.getOffsetDate(0);
      const to_date = utils.getOffsetDate(10);
      const countries = "US,EU,BR";

      this.getFxMarketDataHourly(from_date, to_date, countries, date_ptax)
        .then((response) => {
          const { data, errors } = response.data;

          if (errors && Object.keys(errors).length > 0) {
            console.log(errors);
          }

          const events = data["fx-market-economic-calendar"]?.result || [];
          const fxMarketDailyList = data["fx-market-daily-data"] || null;
          let avgPtax = data["fx-market-avg-ptax"] || null;

          this.fxMarketEconomicCalendar = events;
          this.fxMarketDailyData = fxMarketDailyList;

          localStorage.setItem(
            "fxMarketEconomicCalendar",
            JSON.stringify(events),
          );
          localStorage.setItem(
            "fxMarketDailyData",
            JSON.stringify(fxMarketDailyList),
          );

          if (avgPtax?.error) {
            const fallbackDate = utils.getOffsetDate(-1, true);
            return this.fetchFxMarketDataHourly(fallbackDate);
          }

          this.fxMarketAvgPtax = avgPtax;
          localStorage.setItem("avgPtax", JSON.stringify(avgPtax));
          localStorage.setItem("lastFetchHourlyTime", new Date().toISOString());

          this.hasFetchedHourlySuccess = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchFxMarketDataMinutely() {
      // const topics = "economy_monetary,financial_markets,economy_macro,finance"
      const time_from = this.getYesterdayTimeZone();

      this.getFxMarketDataMinutely(time_from)
        .then((response) => {
          const data = response.data;
          const fxMarketNews = data["fx-market-news"];
          const fxMarketIntradayList = data["fx-market-intraday-data"];
          this.fxMarketNews = fxMarketNews;
          this.fxMarketIntradayData = fxMarketIntradayList;
          localStorage.setItem("fxMarketNews", JSON.stringify(fxMarketNews));
          localStorage.setItem(
            "fxMarketIntradayData",
            JSON.stringify(fxMarketIntradayList),
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkLastFetchHourlyAndUpdate() {
      const lastFetchHourlyTime = localStorage.getItem("lastFetchHourlyTime");
      const now = new Date();

      if (lastFetchHourlyTime) {
        const lastFetchDate = new Date(lastFetchHourlyTime);
        const timeDifference = (now - lastFetchDate) / (1000 * 60);

        if (timeDifference > 60) {
          this.fetchFxMarketDataHourly();
          return;
        }
      } else {
        this.fetchFxMarketDataHourly();
      }
      this.fxMarketEconomicCalendar = JSON.parse(
        localStorage.getItem("fxMarketEconomicCalendar"),
      );
      this.fxMarketAvgPtax = JSON.parse(localStorage.getItem("avgPtax"));
      this.fxMarketDailyData = JSON.parse(
        localStorage.getItem("fxMarketDailyData"),
      );
    },
    fetchMinutelyAndUpdate() {
      this.fetchFxMarketDataMinutely();
      this.intervalMinutely = setInterval(() => {
        this.fetchFxMarketDataMinutely();
      }, 60000);
      this.fxMarketNews = JSON.parse(localStorage.getItem("fxMarketNews"));
      this.fxMarketIntradayData = JSON.parse(
        localStorage.getItem("fxMarketIntradayData"),
      );
    },
    removeLocalStorages() {
      localStorage.removeItem("fxMarketEconomicCalendar");
      localStorage.removeItem("fxMarketDailyData");
      localStorage.removeItem("avgPtax");
      localStorage.removeItem("lastFetchHourlyTime");
      localStorage.removeItem("fxMarketNews");
      localStorage.removeItem("fxMarketIntradayData");
      localStorage.removeItem("cachedMarketData");
    },
    closeGroup(index) {
      this.$set(this.openGroups, index, false);
    },
    closeAllGroups() {
      Object.keys(this.openGroups).forEach((index) => {
        this.$set(this.openGroups, index, false);
      });
    },
    handleMenuClick(menu, idx) {
      if (this.$route.path === menu.to) return;
      this.closeAllGroups(idx);
      this.$router.push({ path: menu.to });
    },
    redirectToProPurchase() {
      const url = "#";
      window.open(url, "_blank");
    },
  },
};
</script>
<style scoped>
.v-app-bar {
  display: flex;
  z-index: 20;
  justify-content: space-between;
  left: 0 !important;
  width: 100% !important;

}

::v-deep .v-toolbar__content,
.v-toolbar__extension {
  flex-grow: 1 !important;
  min-width: 0 !important;
}

.navbar-inner {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  height:100%;
  justify-content: space-between;
  gap: 1.2rem;
  overflow: hidden;
}

.navbar {
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.06) !important;
  backdrop-filter: saturate(140%) blur(8px) !important;
  display: flex;
  flex-grow: 1;
  min-width: 0;
  width: 100%;
}

.img-logo {
  width: 110px;
  max-width: 120px;
  left: 0;
  margin-right: 0;
}

.market-bar-wrap {
  display: flex;
  /* The market content owns all available space between the page title and menus. */
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}

a {
  color: white;
  text-decoration: none;
  position: relative;
}


.is-active {
  color: #ffbf00;
  border-bottom: 1px solid #ffbf00;
}

.navbar--mobile .navbar-inner {
  justify-content: space-between;
  width: 100%;
}
</style>
